import React, { useState, useEffect, memo, useMemo, useRef } from 'react';
import Header from '../layout/Header';
import Paginated from './customersList/Paginated';
import { Link, useLocation } from 'react-router-dom';
import { COLUMNS } from './customersList/column';
import { importIcon } from '../../Image/Index';
import { connect } from 'react-redux';
import { getCustomer, clearCustomer } from '../../actions/customer';
import { decrypt } from '../../utils/encodingdecoding';
import { COLUMNS1 } from './customersList/column1';
import ClipLoader from 'react-spinners/ClipLoader';
import { getSchemaList } from '../../actions/auth';
import swal from 'sweetalert';
import moment from 'moment';

const Participants = memo(({ getCustomer, Customer, clearCustomer }) => {
    const location = useLocation();
    const [data, setData] = useState([]);
    const [customerCount, setCustomerCount] = useState();
    const [response, setResponse] = useState([]);
    const [shemaData, setSchemaData] = useState();
    const [loader, setLoader] = useState(true);
    let id = decrypt(localStorage.getItem('Id'));

    const [testAccounts, setTestAccounts] = useState(false);

    const normalizeKey = (key) => {
        return key.charAt(0).toLowerCase() + key.slice(1);
    };

    useEffect(() => {
        setResponse(Customer?.data);
    }, [Customer]);

    const fetchSchemaList = () => {
        setLoader(true);
        const token = JSON.parse(localStorage.getItem('token_gen'));
        getSchemaList(token?.access_token).then((res) => {
            setSchemaData(res?.schema?.properties);
        });
    };

    useEffect(() => {
        fetchSchemaList();
    }, []);

    useEffect(() => {
        const temp = response?.data?.data;
        if (!temp) {
            setData([]);
            return;
        }
        if (temp) {
            const processed = temp
                .map((val) => {
                    (val.action = (
                        <Link
                            to={`/customer-view/${val?.customerData?.customercode}`}
                            state={{
                                customerCode: val?.customerData?.customercode,
                            }}
                            className='edit_btn'
                        >
                            <i className='fa-solid fa-eye'></i>
                            <div className='show_div'>View Details</div>
                        </Link>
                    ));

                    if (shemaData) {
                        const allowedFields = ["firstName", "slogan"];

                        Object.keys(shemaData)?.forEach((key) => {
                            if (shemaData[key]?.isFormView && allowedFields.includes(key)) {
                                const normalizedKey = normalizeKey(key);
                                let value = val.customerData[normalizedKey];

                                if (key === "createdAt" && value) {
                                    value = moment(value).format("DD-MM-YYYY");
                                }

                                if (value === true) value = "Yes";
                                else if (value === false) value = "No";

                                val[key] = value ?? "";
                            }
                        });
                    }

                    return val;
                })
                .filter((val) => val.slogan && val.slogan.trim() !== "");

            setData(processed);
        }
    }, [response, shemaData]);

    const [search, setSearch] = useState('');
    const debounceRef = useRef(null);
    const abortControllerRef = useRef(null);

    const fetch = async (
        testAccounts = false,
        searchText = '',
        showLoader = true,
    ) => {
        if (abortControllerRef.current) {
            abortControllerRef.current.abort();
        }

        const controller = new AbortController();
        abortControllerRef.current = controller;

        try {
            showLoader && setLoader(true);
            await clearCustomer();

            const token = JSON.parse(localStorage.getItem('token_gen'));
            const id = localStorage.getItem('Id');

            await getCustomer(
                token?.access_token,
                id,
                1,
                50,
                searchText,
                testAccounts,
                { signal: controller.signal },
            );
        } catch (err) {
            if (err.name !== 'AbortError') {
                console.error('Customer fetch failed:', err);
            }
        } finally {
            showLoader && setLoader(false);
        }
    };

    const dynamicColumns = useMemo(() => {
        if (!shemaData) return [];

        const allowedFields = ["firstName", "slogan"];

        return Object.entries(shemaData)
            .filter(([key, value]) =>
                value.isFormView && allowedFields.includes(key)
            )
            .map(([key, value]) => ({
                Header: value.fielddisplayname || value.label || key,
                Footer: value.fielddisplayname || value.label || key,
                accessor: key,
            }));
    }, [shemaData]);

    const columns = useMemo(() => {
        const staticColumns = [

            ...dynamicColumns,
            {
                Header: 'Action',
                accessor: 'action',
                Cell: ({ row }) => (
                    <div className="d-flex justify-content-center align-items-center h-100">
                        <Link
                            to={`/customer-view/${row.original?.customerData?.customercode}`}
                            state={{
                                customerCode: row.original?.customerData?.customercode,
                            }}
                            className="d-flex align-items-center gap-2 text-decoration-none"
                        >
                            <i className="fa-solid fa-eye"></i>
                            <span>View Details</span>
                        </Link>
                    </div>
                ),
            }
        ];
        return staticColumns;
    }, [dynamicColumns]);

    const searchableKeys = useMemo(() => {
        return columns
            .map((col) => col.accessor)
            .filter(
                (key) => key && typeof key === 'string' && key !== 'action', // ignore JSX column
            );
    }, [columns]);

    const objectContainsSearch = (row, query, keys) => {
        if (!row || !query) return true;

        const q = query.toLowerCase();

        return keys.some((key) => {
            const value = row[key];

            if (value === null || value === undefined) return false;

            if (typeof value === 'string' || typeof value === 'number') {
                return String(value).toLowerCase().includes(q);
            }

            if (Array.isArray(value)) {
                return value.some(
                    (v) =>
                        (typeof v === 'string' || typeof v === 'number') &&
                        String(v).toLowerCase().includes(q),
                );
            }

            return false;
        });
    };

    const isInitialRender = useRef(true);

    useEffect(() => {
        if (isInitialRender.current) {
            isInitialRender.current = false;
            return;
        }
        if (debounceRef.current) clearTimeout(debounceRef.current);
        debounceRef.current = setTimeout(() => {
            if (!search.trim()) {
                fetch(testAccounts, '', true);
                return;
            }

            const localMatches = data.filter((row) =>
                objectContainsSearch(row, search, searchableKeys),
            );
            if (localMatches.length > 0) {
                setData(localMatches);
            } else {
                fetch(testAccounts, search);
            }
        }, 500);

        return () => clearTimeout(debounceRef.current);
    }, [search, testAccounts, searchableKeys]);

    const generateCSV = () => {
        try {
            if (!data || data.length === 0) {
                alert('No customer data available to download!');
                return;
            }
            const downloadColumns = columns?.filter(
                (col) => col.accessor !== 'action',
            );
            const headers = downloadColumns.map((col) => col.Header);
            const rows = data?.map((item) => {
                return downloadColumns?.map((col) => {
                    const value = item[col.accessor];
                    if (value === 0) return '0';
                    if (value === null || value === undefined) return '';
                    return value.toString();
                });
            });
            const csvContent = [headers, ...rows]
                .map((row) => row.join(','))
                .join('\n');
            const encodedUri = encodeURI(
                'data:text/csv;charset=utf-8,' + csvContent,
            );
            const link = document.createElement('a');
            link.setAttribute('href', encodedUri);
            link.setAttribute('download', 'customers_data.csv');
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        } catch (error) {
            console.error('CSV Download Error:', error);
            alert('Failed to generate CSV. Please try again.');
        }
    };

    useEffect(() => {
        setCustomerCount(Customer?.data?.data?.totalCount);
    }, [Customer]);

    useEffect(() => {
        return () => {
            setSearch('');
            if (abortControllerRef.current) {
                abortControllerRef.current.abort();
            }
        };
    }, []);

    return (
        <>
            <Header
                name={
                    location?.pathname?.includes('channel-partner')
                        ? 'User Management'
                        : 'Customer'
                }
            />
            {loader && (
                <div className='mainPreloaderMain'>
                    <div className='mainPreloader'>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                    </div>
                </div>
            )}
            <div className='dashboard__content'>
                <div className='container-fluid'>
                    <div className='dashboard__customersCard'>
                        <div className='dashboard__header'>
                            <div className='dashboard__left'>
                                <h4>
                                    Participant List{' '}
                                </h4>
                            </div>

                            <div className='dashboard__right'>
                                <button
                                    onClick={generateCSV}
                                    className='btn btn-default'>
                                    <i
                                        className='fa-solid fa-download'
                                        style={{ marginRight: '10px' }}></i>
                                    Download Participants
                                </button>

                            </div>
                        </div>
                        <div className='dashboard__body'>
                            <Paginated
                                data={data}
                                columns={columns}
                                loader={loader}
                                setLoader={setLoader}
                                testAccounts={testAccounts}
                                search={search}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
});

const mapStateToProps = (state) => ({
    Customer: state.Customer,
});
const mapDispatchToProps = {
    getCustomer,
    clearCustomer,
};

export default connect(mapStateToProps, mapDispatchToProps)(Participants);
